// extracted by mini-css-extract-plugin
export default {"container":"style_container__F4+Fz","cardValores":"style_cardValores__X6O-g","icon":"style_icon__7n7QC"};